// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__GdR4G","legacyBtn":"MutateMid_legacyBtn__2zKUr"};